import React from 'react';

import PropTypes from 'prop-types';

import usePayment from '../../../hooks/providers/usePayment';

const ContactEmailsList = ({linkColor = '#90a8fc'}) => {
  const {subscriptionContactInfo} = usePayment();
  const mails = subscriptionContactInfo.split(',');

  const mailToLinks = mails.map((singleMail, i) => {
    const trimmedEmail = singleMail.trim();
    return (
      <React.Fragment key={trimmedEmail}>
        {i !== 0 && `, `}
        <a style={{color: linkColor || '#90a8fc'}} href={`mailto:${trimmedEmail}`}>
          {trimmedEmail}
        </a>
      </React.Fragment>
    );
  });

  return mailToLinks;
};

ContactEmailsList.propTypes = {
  linkColor: PropTypes.string
};

export default ContactEmailsList;
